module.exports = __webpack_public_path__ + "static/media/error.da7228e4.svg";